import objectPath from 'object-path'

export const getConditionRuleJsonForm = ({
  jsonForm = {},
  isUiChanged = {},
  config = {},
}) => {
  let formComponentName = config?.formComponent?.name
  if (config?.isFormComponent && formComponentName) {
    return (
      objectPath.get(isUiChanged, [
        'tabForm',
        formComponentName,
        'jsonForm',
      ]) || jsonForm
    )
  }

  return jsonForm
}
